/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const SettingsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="SettingsIcon">
    <path
      d="M3.8 11.807a4.394 4.394 0 0 1 2.395 1.907l.042.073c.555.96.713 2.064.497 3.101l-.014.064.054.038a7.3 7.3 0 0 0 1.183.684l.06.028.049-.044A4.394 4.394 0 0 1 11 16.537c1.11 0 2.146.414 2.935 1.121l.05.044.059-.028a7.3 7.3 0 0 0 1.183-.684l.054-.038-.014-.064a4.394 4.394 0 0 1 .497-3.101 4.394 4.394 0 0 1 2.437-1.98l.063-.02.006-.066a7.412 7.412 0 0 0 0-1.369l-.006-.065-.063-.02a4.394 4.394 0 0 1-2.438-1.98 4.394 4.394 0 0 1-.497-3.102l.014-.064-.053-.038a7.29 7.29 0 0 0-1.184-.684l-.06-.028-.049.044a4.394 4.394 0 0 1-2.933 1.121 4.394 4.394 0 0 1-2.935-1.12l-.05-.045-.059.028c-.415.19-.811.42-1.184.684l-.053.038.014.064a4.394 4.394 0 0 1-.497 3.101 4.394 4.394 0 0 1-2.437 1.98l-.063.021-.006.065a7.412 7.412 0 0 0 0 1.369l.006.065.063.02Zm-1.7-.77c0-.742.09-1.462.262-2.151a2.8 2.8 0 0 0 2.457-4.254A8.891 8.891 0 0 1 8.542 2.48a2.8 2.8 0 0 0 4.915 0 8.892 8.892 0 0 1 3.723 2.152 2.8 2.8 0 0 0 2.459 4.255c.17.688.261 1.408.261 2.15a8.93 8.93 0 0 1-.262 2.15 2.8 2.8 0 0 0-2.458 4.254 8.89 8.89 0 0 1-3.723 2.152 2.801 2.801 0 0 0-4.915 0 8.891 8.891 0 0 1-3.723-2.151 2.8 2.8 0 0 0-2.458-4.256 8.952 8.952 0 0 1-.261-2.15Zm8.9 2.6a2.6 2.6 0 1 1 0-5.2 2.6 2.6 0 0 1 0 5.2Zm0-1.6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      fill="var(--main-text-primary)"
      stroke="var(--main-bg-surface)"
      strokeWidth={0.2}
    />
  </svg>
);

export default SettingsIcon;
